// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "mundo-gif-be357.firebaseapp.com",
  "projectId": "mundo-gif-be357",
  "storageBucket": "mundo-gif-be357.appspot.com",
  "messagingSenderId": "469818162953",
  "appId": "1:469818162953:web:76ab2f2153facd6d4cddd8",
  "measurementId": "G-96YV26MLBT",
  "apiKey": "AIzaSyA0Lt8NVM9iOyDt-1WTV65YrSzyLzuMEmM"
};
